module.exports = __webpack_public_path__ + "static/media/Checkmark.549d78c7.svg";